const usernamePattern = /^[a-zA-Z0-9._-]+$/;

const trim = (value) => value.trim();

export function normalizeUsername(value) {
  return trim(value).toLowerCase();
}

export function validateUsername(value) {
  const normalized = normalizeUsername(value);

  if (!normalized) {
    return "El nombre de usuario es obligatorio.";
  }

  if (normalized.length < 3) {
    return "El nombre de usuario debe tener al menos 3 caracteres.";
  }

  if (normalized.length > 30) {
    return "El nombre de usuario es demasiado largo.";
  }

  if (!usernamePattern.test(normalized)) {
    return "Usá solo letras, números, puntos, guiones y guiones bajos.";
  }

  return "";
}
